import { space, type ViewportClass } from "@tokens/index";

/**
 * Shell measures shared by every page chrome.
 *
 * Layout code reads the viewport class and asks these helpers; it never
 * repeats a pixel value.
 */

/** The wordmark. The bar says only this; the sign-in card carries the full name. */
export const APP_NAME = "Einstein";

export const TOP_BAR_HEIGHT = 52;
export const TOP_BAR_HEIGHT_COMPACT = 48;

/** Search well cap on `expanded` and wider. */
export const SEARCH_MAX_WIDTH = 560;

/**
 * Floor of each side column on `expanded`+. Both sides share it, so the
 * search well sits on the optical center. It holds the brand with its
 * environment chip on the left and the connection label plus a named
 * account trigger on the right.
 */
export const TOP_BAR_SIDE_MIN_WIDTH = 320;

/**
 * Search well floor. The brand wordmark truncates before the search well
 * shrinks below this; the bar never overflows.
 */
export function searchMinWidth(viewport: ViewportClass): number {
    return viewport === "medium" ? 200 : 220;
}

/** Horizontal page gutter for the viewport class. */
export function contentGutter(viewport: ViewportClass): string {
    return viewport === "compact" ? space[4] : space[6];
}

/** Vertical page padding for scrolling content areas. */
export function contentBlockPadding(viewport: ViewportClass): string {
    return viewport === "compact" ? space[4] : space[6];
}
